import { FormField } from '@/types';
import Input from '@components/Form/Input';

function SingleLineField(props: FormField) {
  const {
    label,
    clean_name: cleanName,
    help_text: helpText,
    required,
    validation,
    submitted,
    infotext,
    min_chars: minChars,
    max_chars: maxChars,
    pattern,
  } = props;

  return (
    <Input
      label={label}
      type='text'
      id={cleanName}
      placeholder={helpText}
      required={required}
      validation={validation}
      submitted={submitted}
      infotext={infotext}
      min_chars={minChars}
      max_chars={maxChars}
      pattern={pattern}
    />
  );
}

export default SingleLineField;
